module.exports = __webpack_public_path__ + "img/bg-section-06.e10077f3.svg";